import React from 'react'
import Item from '../../../item'

const TrackList = (props) =>
<div className="Tracker">
    {
        props.items.map(e =>
            <Item type="min" {...e} key={e.id} tracker/>
        )
    }
</div>

export default TrackList


// WEBPACK FOOTER //
// ./src/ui/screens/HomeScreen/TrackListScreen/index.js